import { Injectable } from '@angular/core';
import { environment } from '@env';

@Injectable({
	providedIn: 'root',
})
export class GoogleMapsLoaderService {
	private promise: Promise<void> | null = null;

	load(): Promise<void> {
		if (this.promise) {
			return this.promise;
		}

		this.promise = new Promise((resolve, reject) => {
			if (window.google?.maps) {
				resolve();
				return;
			}

			const script = document.createElement('script');
			script.src = `https://maps.google.com.au/maps/api/js?key=${environment.googleMapsApiKey}&libraries=geometry,places&language=en`;
			script.async = true;
			script.defer = true;

			script.onload = () => resolve();
			script.onerror = () => reject('Google Maps failed to load');

			document.head.appendChild(script);
		});

		return this.promise;
	}
}
